var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"chip"},[_vm._v(" "+_vm._s(_vm.value)+" "),_c('img',{class:{ show: _vm.edit },attrs:{"src":"/images/close.svg"},on:{"click":_vm.remove}})])
}
var staticRenderFns = []

export { render, staticRenderFns }